import { HTTP } from './common'

export const User = {
  get (id) {
    return HTTP.get('users/' + id + '/').then(response => {
      return response;
    });
  },
  create (data) {
    return HTTP.post('users/', data).then(response => {
      return response;
    }).catch(error => {
        return error;
    });
  },
  update (id, data) {
    return HTTP.put('users/' + id + '/', data).then( (response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  },
  resetPassword (data) {
    return HTTP.post('users/reset-password/', data, {headers: {}});
  },
}